// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__aqHTk","comment":"styles_comment__3jPSn"};